import { gql } from 'urql';

const DisburseFromLineOfCredit = gql`
  mutation disburseFromLineOfCredit(
    $idempotencyId: IdempotencyToken!
    $tierId: ID!
    $autoPayEnabled: Boolean!
  ) {
    disburseFromLineOfCredit(
      idempotencyId: $idempotencyId
      tierId: $tierId
      autoPayEnabled: $autoPayEnabled
    ) {
      ... on DisburseFromLineOfCreditSuccess {
        __typename
        action
        lineOfCreditId
        title
        message
      }
      ... on DisburseFromLineOfCreditError {
        __typename
        errorTitle: title
        errorMessage: message
        code
      }
    }
  }
`;

export default DisburseFromLineOfCredit;
